import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ReactComponent as Info } from 'assets/images/icons/Info.svg';

const Disclaimer = () => {
    const { t, i18n } = useTranslation();
    return i18n.exists('disclaimer_price') && <OverlayTrigger overlay={<Tooltip>{t('disclaimer_price')}</Tooltip>}>
        <small className="c-price__hint">
            <Info className="c-price__hint-ico" />
        </small>
    </OverlayTrigger>;
}

export default Disclaimer;
